import { type GooglePlacesAddress } from '../types';

/**
 * Formats a Google Places address into a human readable address.
 */
export const formatGoogleAddress = (
  address: Partial<GooglePlacesAddress> & Readonly<{ name?: string | null }>,
  withName?: boolean,
  streetOnly?: boolean,
) => {
  const { name = '', street = '', city = '', state = '', zipCode = '' } = address ?? {};

  const stateAndZipCode = `${state} ${zipCode}`.trim();
  const addressPartials = streetOnly ? [street] : [street, city, stateAndZipCode]; // prettier-ignore
  const formattedAddress = addressPartials.filter(Boolean).join(', ');
  const shouldAddName = Boolean(withName && name);

  if (!formattedAddress) return '';

  return shouldAddName ? `${name} · ${formattedAddress}` : formattedAddress;
};
